/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OofBelt { 
    color?: string;
    cottonLayer?: number;
    edge?: OofBelt.EdgeEnum;
    elasticBeltType?: OofBelt.ElasticBeltTypeEnum;
    growingBeltType?: OofBelt.GrowingBeltTypeEnum;
    labelPlate?: string;
    labelPlateWithFrequency?: boolean;
    labelPlateWithId?: boolean;
    length?: number;
    maximalLength?: number;
    minimalLength?: number;
    paintedLabel?: string;
    protective?: boolean;
    punchingScrewSize?: string;
    punchingSpace?: number;
    quickRelease?: boolean;
    reflectiveStripe?: boolean;
    shape?: OofBelt.ShapeEnum;
    solar?: boolean;
    thickness?: OofBelt.ThicknessEnum;
    width?: number;
}
export namespace OofBelt {
    export const EdgeEnum = {
        Rounded: 'rounded',
        Smooth: 'smooth'
    } as const;
    export type EdgeEnum = typeof EdgeEnum[keyof typeof EdgeEnum];
    export const ElasticBeltTypeEnum = {
        Type1: 'type 1',
        Type2: 'type 2',
        ElasticMooseCollar: 'elastic moose collar'
    } as const;
    export type ElasticBeltTypeEnum = typeof ElasticBeltTypeEnum[keyof typeof ElasticBeltTypeEnum];
    export const GrowingBeltTypeEnum = {
        G1: 'G-1'
    } as const;
    export type GrowingBeltTypeEnum = typeof GrowingBeltTypeEnum[keyof typeof GrowingBeltTypeEnum];
    export const ShapeEnum = {
        Oval: 'oval',
        Round: 'round',
        OvalRound: 'oval-round',
        DropShaped: 'drop-shaped'
    } as const;
    export type ShapeEnum = typeof ShapeEnum[keyof typeof ShapeEnum];
    export const ThicknessEnum = {
        StSt: 'ST_ST',
        SfSf: 'SF_SF',
        StSf: 'ST_SF',
        SolarBelt: 'SOLAR_BELT',
        StStStSt: 'ST_ST_ST_ST',
        ElasticBand: 'ELASTIC_BAND'
    } as const;
    export type ThicknessEnum = typeof ThicknessEnum[keyof typeof ThicknessEnum];
}


